export default "__VITE_ASSET__CHKp6m_H__"